/**
 * Route Configuration
 * 
 * =====================================================
 * 🔐 ADMIN LOGIN URL - CHANGE THIS PERIODICALLY
 * =====================================================
 * 
 * To change the admin login URL:
 * 1. Open this file
 * 2. Change the ADMIN_LOGIN_PATH value below
 * 3. Save and redeploy
 * 4. Share the new URL with system admins
 * 
 * Tips for choosing a URL:
 * - Use random characters: /x7k9m2p4
 * - Avoid obvious words: don't use /admin, /system, /internal
 * - Mix letters and numbers: /a3b7c9
 * - Keep it short enough to remember/share
 * 
 */

// ⚠️ CHANGE THIS VALUE TO UPDATE ADMIN LOGIN URL
export const ADMIN_LOGIN_PATH = '/x7k9m2p4';

// Other route paths
export const ROUTES = {
  // Public routes
  LANDING: '/',
  LOGIN: ADMIN_LOGIN_PATH,
  
  // Protected routes (admin only)
  DASHBOARD: '/dashboard',
  USERS: '/users',
  BOOKS: '/books',
  REQUESTS: '/requests',
  ANALYTICS: '/analytics',
  
  // Hidden routes (not linked anywhere)
  ADMIN_LOGIN: ADMIN_LOGIN_PATH,
} as const;